import React, { Component } from 'react'
import { Button, Popconfirm, Select, Table, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import SideNav from '../SideNav';
import Filter from './Filter';
import BatchMark from './BatchMark';
import RemittanceModal from './RemittanceModal';
import SingleMark from './SingleMark';
import UpdateLog from './UpdateLog';
import moment from 'moment';

const statusList = [
    {label: '待请款', value: 'Pending'}, 
    {label: '客户审批中', value: 'Approval_Progress'},
    {label: '未登记请款（客户已审批）', value: 'Unregistered_Payment'},
    {label: '已登记请款待开票', value: 'Registered_Issue_Invoice'},
    {label: '已开票未回款', value: 'Invoiced_Not_Paid'},
    {label: '已开票已回款', value: 'Invoiced_Paid'},
    {label: '未开票已回款', value: 'Not_Invoiced_Paid'},
    {label: '内部吸收_临床资源部吸收', value: 'Clinical_Resources_Absorption'},
    {label: '内部吸收_项目承担', value: 'Project_Undertaking'},
    {label: '其他', value: 'OTHER'},
];


export default class PTReimburse extends Component {
    state = {
        data: [],
        loading: false,
        canAdd: false,
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        selectedRowKeys: [],
        arry: [],
        batchMarkData: [],
    }

    componentDidMount() {
        this.loadData();
    }

    //清除searchParams中不必要的对象数据
    splitParams = params => {
        const result = {};
        for (const [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { stageIds } = searchParams;
        this.setState({ loading: true })
        const options = {
            method: 'POST',
            url: API_URL.contract.queryPtPriceRecordList,
            data: {
                offset: current,
                limit: pageSize,
                ...this.splitParams(searchParams),
                stageIds: (stageIds || []).join(','),
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                datas.forEach((el, index) => el.index = (current - 1) * pageSize + index + 1);
                pagination.total = totalCount
                this.setState({ 
                    data: datas, 
                    pagination, 
                    loading: false,
                })
            },
        };
        $.sendRequest(options);
    }

    handleTableChange = (pagination) => {
        this.setState({ 
            pagination 
        },() => {
            this.loadData();
        })
    }

    getColumns = () => {
        const columns = [{
            title: '报销单号',
            dataIndex: 'reimbursementNum',
            key: 'reimbursementNum',
            width: 120,
            fixed: 'left',
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 120,
        }, {
            title: 'JDE项目号',
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            width: 120,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 120,
        }, {
            title: '项目阶段',
            dataIndex: 'invStageName',
            key: 'invStageName',
            width: 120,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 120,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 120,
        }, {
            title: '客户名称',
            dataIndex: 'customerCompanyNameCode',
            key: 'customerCompanyNameCode',
            width: 120,
        }, {
            title: '是否客户承担',
            dataIndex: 'whetherCustomerBearName',
            key: 'whetherCustomerBearName',
            width: 120,
        }, {
            title: '申请事由',
            dataIndex: 'matterReason',
            key: 'matterReason',
            width: 120,
        }, {
            title: '报销审批完成时间',
            dataIndex: 'approvalCompletionDate',
            key: 'approvalCompletionDate',
            width: 120,
        }, {
            title: 'Ariba&OA审批通过金额',
            dataIndex: 'approvedAmount',
            key: 'approvedAmount',
            width: 120,
            render: text => (text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '') 
        }, {
            title: '申请结算金额（含税）',
            dataIndex: 'actualExpenses',
            key: 'actualExpenses',
            width: 120,
            render: text => (text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '') 
        }, {
            title: '申请结算税率（%）',
            dataIndex: 'actualExpensesRate',
            key: 'actualExpensesRate',
            width: 120,
        }, {
            title: '申请结算税费',
            dataIndex: 'actualExpensesTax',
            key: 'actualExpensesTax',
            width: 120,
            render: text => ((text == 0 || text) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '') 
        }, {
            title: '最终结算金额（含税）',
            dataIndex: 'lastExpenses',
            key: 'lastExpenses',
            width: 120,
            render: text => ((text == 0 || text) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '') 
        }, {
            title: '客户CSA',
            dataIndex: 'csaUserNameCode',
            key: 'csaUserNameCode',
            width: 120,
        }, {
            title: 'PM',
            dataIndex: 'pmUserNameCode',
            key: 'pmUserNameCode',
            width: 120,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 120,
        }, {
            title: '申请人',
            dataIndex: 'applicantUserName',
            key: 'applicantUserName',
            width: 120,
            render: (text, record) => {
                const { applicantUserName, applicantUserCode } = record;
                return (applicantUserName && applicantUserCode) ? `${applicantUserName}[${applicantUserCode}]` : ''
            }
        }, {
            title: '流程状态',
            dataIndex: 'processStatus',
            key: 'processStatus',
            width: 120,
        }, {
            title: '状态',
            dataIndex: 'ptPriceStatusName',
            key: 'ptPriceStatusName',
            width: 120,
        }, {
            title: '其他状态说明',
            dataIndex: 'statusRemark',
            key: 'statusRemark',
            width: 120,
        }, {
            title: '费用类型',
            dataIndex: 'priceType',
            key: 'priceType',
            width: 120,
        }, {
            title: '请款单号',
            dataIndex: 'remittanceCodes',
            key: 'remittanceCodes',
            width: 100,
            render: (text, record) => {
                const { remittanceApplicationIds } = record;
                return <a onClick={() => this.showRemittanceModal(remittanceApplicationIds)}>{text}</a>
            }
        }, {
            title: '请款节点',
            dataIndex: 'remittanceNodes',
            key: 'remittanceNodes',
            width: 120,
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            width: 140,
            fixed: 'right',
            render: (text, record, index) => {
                const { canProcess } = record;
                return (
                    <span>
                        {
                            canProcess == 1 && <span> 
                                <a onClick={() => this.singleMarkRef.show(record)}>标记状态</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        
                        <a onClick={() => this.updateLogRef.show(record)}>更新日志</a>
                    </span>
                )
            }
        }]
        return columns
    }

    showRemittanceModal = (contractRemittanceApplicationIds) => {
            if (!contractRemittanceApplicationIds) return
            const options = {
                method: 'POST',
                url: API_URL.contract.queryContractRemittanceList,
                data: {
                    contractRemittanceApplicationIds
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas = [] } = res.data;
                    this.remittanceModalRef.show([], datas)
                },
            };
            $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    onSelectChange = (record, selected) => {
        const { selectedRowKeys, arry, data, batchMarkData } = this.state;
        if (selected) {
            const isExist = selectedRowKeys.some(item => item == record.index);
            !isExist && selectedRowKeys.push(record.index);
            const isIdExist = arry.some(item => item == record.ptPriceRecordId);
            if (!isIdExist) {
                arry.push(record.ptPriceRecordId);
                data.map(el => {
                    if (el.ptPriceRecordId == record.ptPriceRecordId) {
                        batchMarkData.push({...el});
                    }
                });
            }
        } else {
            let idx;
            selectedRowKeys.forEach((item, index) => {
                if (record.index == item) {
                    idx = index;
                }
            });
            (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

            // 删除已存在的id
            let idIdx;
            arry.forEach((item, index) => {
                if (record.ptPriceRecordId == item) {
                    idIdx = index;
                }
            });
            if (idIdx || (!idIdx && idIdx === 0)) {
                arry.splice(idIdx, 1);
                batchMarkData.splice(idIdx, 1);
            }
        }
        this.setState({
            arry,
            selectedRowKeys,
            batchMarkData,
        });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        const { arry, selectedRowKeys, data, batchMarkData } = this.state;
        if (selected) {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                !(idx || (!idx && idx === 0)) && selectedRowKeys.push(item.index);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.ptPriceRecordId) {
                        idIdx = index;
                    }
                });
                if (!(idIdx || (!idIdx && idIdx === 0))) {
                    arry.push(item.ptPriceRecordId);
                    data.map(el => {
                        if (el.ptPriceRecordId == item.ptPriceRecordId) {
                            batchMarkData.push({...el});
                        }
                    });
                }
            });
        } else {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.ptPriceRecordId) {
                        idIdx = index;
                    }
                });
                if (idIdx || (!idIdx && idIdx === 0)) {
                    arry.splice(idIdx, 1);
                    batchMarkData.splice(idIdx, 1);
                }
            });
        }
        this.setState({
            arry,
            selectedRowKeys,
            batchMarkData,
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            selectedRowKeys: [],
            arry: [],
            batchMarkData: [],
            pagination,
            curParams: {...searchParams}
        }, () => {
            this.loadData();
        });
    }

    exportData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { stageIds } = searchParams;
        this.setState({ loading: true })
        const options = {
            method: 'POST',
            url: API_URL.contract.exportPtPriceRecordList,
            data: {
                offset: current,
                limit: pageSize,
                ...this.splitParams(searchParams),
                stageIds: (stageIds || []).join(','),
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    batchMark = () => {
        const { batchMarkData } = this.state;
        if (batchMarkData.length == 0) {
            message.warning('不满足标记要求，请重新选择');
            return
        }

        let isSame = true;
        // 判断勾选的数据中，项目简称、客户名称是否相同
        for (let index = 0; index < batchMarkData.length - 1; index++) {
            if (batchMarkData[index].investigationName != batchMarkData[index+1].investigationName || batchMarkData[index].customerCompanyName != batchMarkData[index+1].customerCompanyName) {
                isSame = false;
            };
        };
        
        if (isSame) {
            this.batchMarkRef.show(batchMarkData);
        } else {
            message.warning('不满足标记要求，请重新选择');
        }
    }


    render() {
        const { searchParams, data, pagination, loading, selectedRowKeys, arry } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
            getCheckboxProps: record => ({
                disabled: record.canProcess == 0,
            }),
        };
        
        return (
            <div className="content">
                <SideNav selectKey='ptReimburse' />
                <div className="main">
                    <Filter
                        search={this.search}
                        searchParams={searchParams}
                        onChange={this.handleFilterChange}
                        exportData={this.exportData}
                        batchMark={this.batchMark}
                        statusList={statusList}
                    />
                    <div style={{ color: 'red', margin: '0px 0px 17px 10px' }}>只能对同项目、客户的数据进行批量操作</div>
                    <Table
                        rowSelection={rowSelection}
                        rowKey={record => record.index}
                        scroll={{ x: 2640, y: 460 }}
                        dataSource={data}
                        loading={loading}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <BatchMark
                        ref={el => this.batchMarkRef = el}
                        statusList={statusList}
                        loadData={this.loadData}
                    />
                    <RemittanceModal
                        ref={el => this.remittanceModalRef = el}
                        loadData={this.loadData}
                    />
                    <SingleMark
                        ref={el => this.singleMarkRef = el}
                        statusList={statusList}
                        loadData={this.loadData}
                    />
                    <UpdateLog
                        ref={el => this.updateLogRef = el}
                        loadData={this.loadData}
                    />
                    <RemittanceModal
                        ref={el => this.remittanceModalRef = el}
                        isList={true}
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/ptReimburse/index.js